import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Contemporary_Period_-_Social_Movements_e.g._Civil_Rights_LGBTQ+.png';

function HistoryPageSocialMovementsGo() {
  return (
    <QuizPage
      title="History: Social Movements"
      subTopic="Social Movements (e.g., Civil Rights, LGBTQ+)"
      backgroundImage={historyImage}
      returnPath="/History-Social-Movements"
    />
  );
}

export default HistoryPageSocialMovementsGo;
